var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoucherEportal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 0H2.25C1.00736 0 0 1.00736 0 2.25C0 3.49264 1.00736 4.5 2.25 4.5L2.25 13.5C2.25 14.7426 3.25736 15.75 4.5 15.75H13.5C14.7426 15.75 15.75 14.7426 15.75 13.5V4.5C16.9926 4.5 18 3.49264 18 2.25C18 1.00736 16.9926 0 15.75 0ZM3.375 13.5L3.375 2.25H10.125V14.625H4.5C3.87868 14.625 3.375 14.1213 3.375 13.5ZM12.375 2.25L12.375 14.625H13.5C14.1213 14.625 14.625 14.1213 14.625 13.5V2.25H12.375Z",
    fill: "#5C5E69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucherEportal);
export default __webpack_public_path__ + "static/media/voucher-eportal.203c0f84162c19a7a9a19956f37f2558.svg";
export { ForwardRef as ReactComponent };